import React from 'react';
import useTranslation from '../../../../hooks/useTranslation';
import RichText from '../rich-text';
import { EventPosition } from '../../../../services/analytics-interfaces';

interface DisclaimerFooterProps {
	disclaimers: Set<string>;
}
function DisclaimerFooter({ disclaimers }: DisclaimerFooterProps) {
	const { t } = useTranslation();
	const serviceDisclaimers = Array.from(disclaimers);

	return disclaimers.size !== 0 ? (
		<div
			className="flex flex-col gap-5"
			data-testid="disclaimer-footer">
			{serviceDisclaimers.map((service, i) => (
				<div key={`disclaimer${i}`} className="flex text-sm text-font">
					<RichText
						html={t(`services.${service}.disclaimer`)}
						position={EventPosition.Body}
					/>
				</div>
			))}
		</div>
	) : null;
}

export default DisclaimerFooter;
